import http from "../http";

const workmanage = {
  /**
   * POST 工单质检-质检删除
   */
  DeleteQaTestDict(id) {
    return http.post(`/work_order/QaTests/DeleteQaTestDict?id=${id}`);
  },

  /**
   * POST 工单质检-工单质检
   */
  createQaTestDetail(model) {
    return http.post(`/work_order/QaTests/createQaTestDetail`, model);
  },

  /**
   * POST 工单质检-创建质检
   */
  createQaTestDict(model) {
    return http.post(`/work_order/QaTests/createQaTestDict`, model);
  },

  /**
   * POST 获取工单质检列表
   */
  getPagedList(model) {
    return http.post(`/work_order/QaTests/getPagedList`, model);
  },

  /**
   * GET 查询质检详情
   */
  getQaTestByWorkOrderId(id) {
    return http.get(`/work_order/QaTests/getQaTestByWorkOrderId?id=${id}`);
  },
  /**
   * GET 获取质检分数最大值
   */
  maxScore(filters) {
    return http.get(`/work_order/QaTests/getQaTestDictList`, {
      params: filters,
    });
  },

  /**
   * GET 质检字典列表
   */
  getQaTestDictList(filters) {
    return http.get(`/work_order/QaTests/getQaTestDictList`);
  },
  /**
   * GET 工单详情
   */
  getManageWorkOrderDetail(filters) {
    return http.get(`/work_order/manageWorkOrder/detail`, { params: filters });
  },

  /**
   * GET 获取工单数据统计
   */
  getManageWorkOrderStatistics(filters) {
    return http.get(`/work_order/manageWorkOrder/statistics`);
  },

  /**
   * POST 工单列表
   */
  getManageWkOrderList(model) {
    return http.post(`/work_order/manageWorkOrder/list`, model);
  },

  /**
   * Get 重新打开前检查
   */
  checkOpen(id) {
    return http.get(`/work_order/QaTests/checkOpen?workOrderId=${id}`);
  },
  /**
   * POST 重新打开
   */
  reOpen(model) {
    return http.post(`/work_order/QaTests/open`, model);
  },
  /**
   * POST 强制关闭
   */
  close(model) {
    return http.post(`/work_order/QaTests/close`, model);
  },
  /**
   * POST 工单沟通记录列表
   */
  getManageWkOrderProList(model) {
    return http.post(`/work_order/manageWorkOrder/process/list`, model);
  },
  /**
   * 工单转接记录
   * @param model
   * @returns {Promise<AxiosResponse<any>>}
   */
  getManageWkOrderTransferList(model) {
    return http.post("/work_order/wktransfer/transfer/list", model);
  },
  /**
   * 工单审批记录
   */
  getWkOrderTaskList(id) {
    return http.get(`/work_order/workOrders/flow/taskList?flowId=${id}`);
  },
  /**
   * 提醒
   */
  remind(data) {
    return http.post("/work_order/QaTests/alert", data);
  },

  /**
   * POST 工单驳回
   */
  rejectWkOrder(model) {
    return http.post(`/work_order/manageWorkOrder/reject`, model);
  },
  /**
   * POST 工单转接
   */
  wktransfer(model) {
    return http.post(`/work_order/wktransfer/transfer`, model);
  },
  /**
   * get 导出
   */
  export(model) {
    return http.post(`/QaTests/export?`, model);
  },
  /**
   * 根据workorderId获取详情
   * @param params
   * @returns {Promise<AxiosResponse<any>>}
   */
  getWorkDetailByWorkOrderId(params) {
    return http.get("/work_order/workOrders/getbyworkorderid", { params });
  },
  /**
   * 导出工单数据
   * @param {*} params
   * @returns
   */
  exportWorkOrder(params) {
    return http.post("/work_order/manageWorkOrder/export", params, {
      responseType: "blob",
    });
  },

  /**
   * 获取流程细节数据量
   */
   exportDetailsCount(model) {
    return http.post(`/work_order/manageWorkOrder/exportDetailsCount`, model);
  },

  /**
   * 获取整体数据量
   */
   exportWholeCount(model) {
    return http.post(`/work_order/manageWorkOrder/exportWholeCount`, model);
  },

  /**
   * 工单流程细节数据
   * @param {*} params
   * @returns
   */
   exportDetails(params) {
    return http.post("/work_order/manageWorkOrder/exportDetails", params, {
      responseType: "blob",
    });
  },

  /**
   * 导出工单整体数据列表
   * @param {*} params
   * @returns
   */
   exportWhole(params) {
    return http.post("/work_order/manageWorkOrder/exportWhole", params, {
      responseType: "blob",
    });
  },

};

export default workmanage;
